import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import sessaoStore from "../../stores/SessaoStore";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      sessaoStore.isLoggerIn() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object
};

PrivateRoute.defaultProps = {
  location: null
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/Security/PrivateRoute.js